import moment from "moment";
import { utility } from "../../../utility/utilityProvider";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";

export const CustomCell = (props) => {

  const field = props.field || "";
  let value = '';



  return <td
    className={props?.className ?? ''}
    colSpan={props.colSpan}
    role={"gridcell"}
    aria-colindex={props.ariaColumnIndex}
    aria-selected={props.isSelected}
    {...{
      [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
    }}
    {...useTableKeyboardNavigation(props.id)}
    style={props?.style ?? {}}
  >
    {utility.buildCustomPropertyValue(props.dataItem, field)}
  </td>;
};
